import { render } from "./formularioProductos.vue?vue&type=template&id=4b31e92d"
import script from "./formularioProductos.vue?vue&type=script&lang=js"
export * from "./formularioProductos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__